export class ProductDataSheet {

  constructor(   
    public name?: string,
    public nameNew?: string,
    public customerId?: string
  ) {
  }
}
